<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h3>Nova conversão</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-lg-6 p-2">
          <label for="nome">Nome</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="nome"
            id="nome" [formControl]="form.controls.nome">
          <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
        </div>

        <div class="col-12 col-lg-6 p-2">
          <label for="fornecedor">Fornecedor</label>
            <select class="form-control input-validate" name="fornecedor" id="fornecedor" [formControl]="form.controls.fornecedor">
              <option value="">Selecione</option>
              <option *ngFor="let f of listaFornecedores" [value]="f.id">{{ f.nome | uppercase}}</option>
            </select>
          <app-msg-erro [control]="form.controls.fornecedor"></app-msg-erro>
        </div>
      </div>
    </div>
    <div class="card-header mt-4 bg-white">
      <h3>Dados para conversão</h3>
    </div>
    <div class="card-body">
      <div class="row my-4">
        <div class="col-12 col-md-6 col-lg-6 p-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text font-weight-light px-4 px-lg-4">De</div>
            </div>
            <input type="text" autocomplete="false" class="form-control input-validate text-center" name="valorInicial"
              id="valorInicial" [formControl]="form.controls.valorInicial">
          </div>
            <app-msg-erro [control]="form.controls.valorInicial"></app-msg-erro>
        </div>
        <div class="col-12 col-md-6 col-lg-5 p-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text font-weight-light px-4 px-lg-4">Para</div>
            </div>
            <input type="text" autocomplete="false" class="form-control input-validate text-center" name="valorFinal"
              id="valorFinal" [formControl]="form.controls.valorFinal">
          </div>
            <app-msg-erro [control]="form.controls.valorFinal"></app-msg-erro>
        </div>

        <div class="col-lg-1 p-2 m-auto">
          <button class="btn btn-sm btn-icon btn-success rounded-circle m-auto" (click)="addParamConversao()">
            <i class="mdi mdi-plus"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 p-2">
          <table class="table bg-light rounded">
            <thead class="text-center" *ngIf="listaConversoes.length > 0">
              <tr>
                <th>Valor inicial</th>
                <th>Valor convertido</th>
                <th class="acao-tabela">Ações</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr *ngIf="listaConversoes.length == 0">
                <td class="text-center py-5 text-secondary w-500" colspan="7">
                  Sem registros
                </td>
              </tr>
              <tr *ngFor="let l of listaConversoes">
                <td>{{ l.valorInicial }}</td>
                <td>{{ l.valorFinal }}</td>
                <td class="d-flex align-items-center justify-content-end">
                  <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="editParamConversao(l.id)" class="btn btn-sm btn-icon btn-primary" title="EDITAR">
                    <i class="mdi mdi-pencil"></i>
                  </button></span>
                  <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="delParamConversao(l.id)" class="btn btn-sm btn-danger btn-icon mx-1" title="DELETAR">
                    <i class="mdi mdi-delete"></i>
                  </button></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted mx-xl-4">
      <button class="btn btn-lg px-5 btn-success" [disabled]="form.invalid" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>